import { useState } from "react";
import dayjs from "dayjs";
import { fmtDate, fmtShort } from "./ui";
import { DoItSheet, ExtendedButton } from "./DoIt";
import { useSession } from "../lib/session";

export type MembershipFields = { licensed: boolean; deadline_9m: string | null; deadline_soon?: boolean; membership_original?: string | null;
  membership_extended?: boolean; membership_expired?: boolean };

/** The membership expiry, the same everywhere: the extended date when extended, else the 9-month mark. */
export function MembershipDate({ m, long }: { m: MembershipFields; long?: boolean }) {
  if (m.licensed || !m.deadline_9m) return <>—</>;
  const d = long ? fmtDate(m.deadline_9m) : fmtShort(m.deadline_9m);
  return (
    <span className="nowrap">
      <span className={m.membership_expired ? "pill alert" : m.deadline_soon ? "pill cooling" : ""}>{d}</span>
      {m.membership_extended && <span className="pill warm" style={{ marginLeft: 4 }} title={`Original 9-month mark: ${fmtDate(m.membership_original)}`}>Extended</span>}
      {m.membership_expired && <span className="pill alert" style={{ marginLeft: 4 }}>Expired</span>}
    </span>
  );
}

/** On a team member's profile: expiry, original mark, and the two actions. */
export function MembershipActions({ m }: { m: MembershipFields & { member_id: string; person_id: string; full_name: string } }) {
  const { can } = useSession();
  const [remind, setRemind] = useState(false);
  if (m.licensed || !m.deadline_9m || !can("team", "edit")) return null;
  return (
    <div className="toolbar membership-bar">
      <span className="small">WFG membership expires <b>{fmtDate(m.deadline_9m)}</b>{m.membership_extended ? ` (extended; 9-month mark was ${fmtShort(m.membership_original)})` : ""}{m.membership_expired ? " · expired" : ""}</span>
      <button className="btn small" onClick={() => setRemind(true)}>{m.membership_extended ? "Send final-mark reminder" : "Send extension reminder"}</button>
      <ExtendedButton memberId={m.member_id} mark={m.membership_original ?? m.deadline_9m} extended={m.membership_extended} />
      {remind && <DoItSheet item={{ item_key: `lic:${m.member_id}`, kind: "licensing", area: "team", title: m.full_name,
        why: m.membership_extended ? `Final mark: extended membership ends ${dayjs(m.deadline_9m).format("MMM D")}` : `Membership expires ${fmtDate(m.deadline_9m)}`, person_id: m.person_id, due: m.deadline_9m }} onClose={() => setRemind(false)} />}
    </div>
  );
}
